/**
 * Rutas de Calidad — acceso vía routeAccessMatrix.js
 */
import { Route } from 'react-router-dom'
import ProtectedRoute from '../components/ProtectedRoute.jsx'
import PermissionRoute from '../components/PermissionRoute.jsx'
import PlanesInspeccion from '../pages/calidad/inspection-plans/PlanesInspeccion.jsx'
import AutocontrolCalidad from '../pages/calidad/self-control/AutocontrolCalidad.jsx'
import RegistrosAutocontrol from '../pages/calidad/self-control/RegistrosAutocontrol.jsx'
import CaracteristicasCalidad from '../pages/calidad/quality-characteristics/CaracteristicasCalidad.jsx'
import Defectos from '../pages/calidad/defects/Defectos.jsx'
import ControlEstadistico from '../pages/calidad/statistical-process-control/ControlEstadistico.jsx'
import AccionesCorrectivas from '../pages/calidad/corrective-actions/AccionesCorrectivas.jsx'
import Certificados from '../pages/calidad/certificates/Certificados.jsx'

const withAcl = (Page) => (
  <ProtectedRoute>
    <PermissionRoute>
      <Page />
    </PermissionRoute>
  </ProtectedRoute>
)

export const qualityRoutes = [
  <Route key="planes-inspeccion" path="/planes-inspeccion" element={withAcl(PlanesInspeccion)} />,
  <Route key="autocontrol-calidad" path="/autocontrol-calidad/:planId" element={withAcl(AutocontrolCalidad)} />,
  <Route key="registros-autocontrol" path="/registros-autocontrol" element={withAcl(RegistrosAutocontrol)} />,
  <Route key="caracteristicas-calidad" path="/caracteristicas-calidad" element={withAcl(CaracteristicasCalidad)} />,
  <Route key="defectos" path="/defectos" element={withAcl(Defectos)} />,
  <Route key="control-estadistico" path="/control-estadistico" element={withAcl(ControlEstadistico)} />,
  <Route key="acciones-correctivas" path="/acciones-correctivas" element={withAcl(AccionesCorrectivas)} />,
  <Route key="certificados" path="/certificados" element={withAcl(Certificados)} />,
]
